import { iframeResizer } from "iframe-resizer";

iframeResizer({
   log: false,
   checkOrigin: false,
   heightCalculationMethod: 'documentElementOffset',
}, '[data-pardot-iframe]');

export default function initPardotForms() {
   // Do nothing at the moment. Everything is taken care of above.

   // The actual styling of the form is done on the clients side because this is all iframe stuff.

   // form : 
   // max-width: auto;
   // margin: 0;
}
